import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing, palette }) => ({
  filterGroup: {
    backgroundColor: palette.grey[100],
    padding: spacing(4),
  },
  applyButton: {
    borderRadius: 2,
    fontSize: 13,
    marginLeft: spacing(2),
    padding: "4px 12px",
  },
  clearButton: {
    color: colors.black,
    fontSize: 13,
    textDecoration: "none",
  },
  popoverFilters: {
    padding: "16px 24px",
  },
  popoverHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: `${spacing(3)}px ${spacing(4)}px`,
  },
  popoverHeaderTitle: {
    fontSize: 16,
    fontWeight: "bold",
  },
  popoverButtons: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

export default useStyles;
